import React from 'react'
import injectStyles from 'react-jss'
import classnames from 'classnames'
import List from '@material-ui/core/List'

import styles from '../styles'
import HeaderButton from '../../Header/HeaderButton'
import BellIcon from '../../../Assets/Images/icons/bell'

const NotificationCenterView = ({
  toggleView,
  isActive,
  count = 0,
  classes,
  children,
}) => {
  return (
    <section className={classes.wrapper}>
      <HeaderButton onClick={toggleView} isActive={isActive} count={count}>
        <BellIcon fill={'#FFF'} width={20} height={20} />
      </HeaderButton>
      <div
        className={classnames(classes.contentContainer, { 'active': isActive })}
      >
        {children.length > 0 ? (
          <List component="nav" aria-label="main mailbox folders">
            {children}
          </List>
        ) : (
          <span className={classes.hint}>Empty</span>
        )}
      </div>
    </section>
  )
}

export default injectStyles(styles)(NotificationCenterView)
